import { render, staticRenderFns } from "./WorkShiftInformation.vue?vue&type=template&id=7aefd872&scoped=true"
import script from "./WorkShiftInformation.vue?vue&type=script&lang=js"
export * from "./WorkShiftInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aefd872",
  null
  
)

export default component.exports